import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  AutoBonusPaymentsPageResponse,
  AutoBonusPaymentStatus,
} from "../../../domain/models/integration/auto-bonus-payments.model";
import { AutoBonusPaymentsPort } from "../../../app/ports/integration/auto-bonus-payments.port";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isAutoBonusPaymentsPageResponse } from "../../validators/integration/auto-bonus-payments.validator";

@Injectable()
export class AutoBonusPaymentsHttpAdapter implements AutoBonusPaymentsPort {
  constructor(
    private readonly http: HttpClient,
    @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration,
  ) {}

  getPayments(
    year: number,
    month: number,
    status: AutoBonusPaymentStatus,
    search = "",
  ): Observable<AutoBonusPaymentsPageResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    const path = `/api/v1/auto-bonus/periods/${year}/${month}/payments`;
    let params = new HttpParams().set("status", status);
    const normalizedSearch = search.trim();
    if (normalizedSearch) params = params.set("search", normalizedSearch);

    return this.http.get<unknown>(`${baseUrl}${path}`, { params }).pipe(
      map((response) => {
        if (!isAutoBonusPaymentsPageResponse(response)) {
          throw new Error("La respuesta de pagos de Bono Auto es inválida.");
        }
        return response;
      }),
    );
  }
}
